<template>
    <el-dialog
        :title="`${item ? '编辑' : '添加'}服务`"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
        <el-form :model="serverForm" :rules="rules" ref="serverForm" label-width="120px">
            <el-form-item label="服务名称" prop="name">
                <el-input v-model="serverForm.name" placeholder="请输入服务名称"></el-input>
            </el-form-item>
            <el-form-item label="积分" prop="score">
                <el-input type="number" v-model.number="serverForm.score" placeholder="请输入积分"></el-input>
            </el-form-item>

            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('serverForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('serverForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {addNewProjectService} from "@/api/weilao";

export default {
    name: "addServiceDialog",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        item: {
            type: [Object, String,Boolean],
            default: ''
        }
    },
    data() {
        return {
            serverForm: {
                name: '',
                score: '',
            },
            rules: {
                name: [{required: true, message: '请输入服务名称', trigger: 'blur'}],
                score: [{required: true, message: '请输入积分', trigger: 'blur'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await addNewProjectService(
                this.item ? this.item.id : '',
                this.serverForm.name,
                this.serverForm.score,
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }
    },
    watch: {
        item(){
            if (this.item) {
                this.serverForm.name = this.item.name
                this.serverForm.score = this.item.score
            }else {
                this.serverForm.name = ''
                this.serverForm.score = ''
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
